<template>
  <div style="padding: 60px 0px; background-color: #f0ede5">
    <v-main>
      <v-container>
        <h2 class="section-name">Technologie & Tools</h2>
        <v-row no-gutters justify="center" :style="$vuetify.breakpoint.smAndDown ? 'margin: 32px 0px 0px 0px' : 'margin: 64px 0px 100px 0px'">
          <v-col
            cols="12"
            xl="3"
            lg="3"
            md="3"
            sm="12"
            :style="$vuetify.breakpoint.smAndDown ? '' : 'padding-right: 16px'"
          >
            <div class="technologie-card">
              <v-row no-gutters justify="center">
                <div class="technologie-card-icon">
                  <img
                    src="@/assets/img/technologieIcon/monitorIcon.svg"
                    width="40px"
                    height="40px"
                    alt="icon"
                  />
                </div>
              </v-row>
              <h4 class="technologie-card-title">
                Zertifizierter Treuhandpartner von Bexio
              </h4>
              <span
                >Offizielle Partnerschaft für optimale
                Buchhaltungslösungen</span
              >
            </div>
          </v-col>
          <v-col
            cols="12"
            xl="3"
            lg="3"
            md="3"
            sm="12"
            :style="
              $vuetify.breakpoint.smAndDown
                ? 'padding-top: 24px'
                : 'padding-right: 16px'
            "
          >
            <div class="technologie-card">
              <v-row no-gutters justify="center">
                <div class="technologie-card-icon">
                  <img
                    src="@/assets/img/technologieIcon/settingIcon.svg"
                    width="40px"
                    height="40px"
                    alt="icon"
                  />
                </div>
              </v-row>
              <h4 class="technologie-card-title">
                Alternative Buchhaltungslösungen
              </h4>
              <span>Flexible Software-Auswahl je nach Kundenanforderungen</span>
            </div>
          </v-col>
          <v-col
            cols="12"
            xl="3"
            lg="3"
            md="3"
            sm="12"
            :style="
              $vuetify.breakpoint.smAndDown
                ? 'padding-top: 24px'
                : 'padding-right: 16px'
            "
          >
            <div class="technologie-card">
              <v-row no-gutters justify="center">
                <div class="technologie-card-icon">
                  <img
                    src="@/assets/img/technologieIcon/cloudIcon.svg"
                    width="40px"
                    height="40px"
                    alt="icon"
                  />
                </div>
              </v-row>
              <h4 class="technologie-card-title">Cloudbasierte Systeme</h4>
              <span>Ortsunabhängige Zusammenarbeit für maximale Effizienz</span>
            </div>
          </v-col>
          <v-col
            cols="12"
            xl="3"
            lg="3"
            md="3"
            sm="12"
            :style="
              $vuetify.breakpoint.smAndDown
                ? 'padding-top: 24px'
                : 'padding-right: 16px'
            "
          >
            <div class="technologie-card">
              <v-row no-gutters justify="center">
                <div class="technologie-card-icon">
                  <img
                    src="@/assets/img/technologieIcon/usersIcon.svg"
                    width="40px"
                    height="40px"
                    alt="icon"
                  />
                </div>
              </v-row>
              <h4 class="technologie-card-title">Individuelle Auswahl</h4>
              <span>Maßgeschneiderte Software- Lösungen für jeden Kunden</span>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.technologie-card {
  border-radius: 8px;
  border: 1px solid #e9e4d8;
  background: #fff;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -4px rgba(0, 0, 0, 0.1);
  padding: 25px 29px;
  color: #3e7459;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22.75px;
  height: 100%;
}
.technologie-card-icon {
  width: 64px;
  height: 64px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  background: rgba(192, 149, 89, 0.1);
}
.technologie-card-title {
  color: #163626;
  text-align: center;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
  margin: 18px 0px;
}
</style>